import { fillArr } from '@hglobal/common';

import { GetAssigneesRes } from '../models/get-assignees-res.model';

export function getAssigneesMock(count = 14): GetAssigneesRes {
  return {
    users: fillArr(count, i => ({
      id: i,
      fullName: 'Aleksander Sidorov',
      imageUrl: 'https://picsum.photos/200?random=2',
      position: 'Head of QA',
      email: `t.biriukov${i}@pin-up.business`,
    })),
  };
}
